export const EMAIL_CAMPAIGN_LIST = 'EMAIL_CAMPAIGN_LIST'
export const EMAIL_CAMPAIGN_DETAIL = 'EMAIL_CAMPAIGN_DETAIL'
export const EMAIL_CAMPAIGN_BALANCE = 'EMAIL_CAMPAIGN_BALANCE'
export const FETCH_VERIFIED_EMAIL_ADDRESSES = 'FETCH_VERIFIED_EMAIL_ADDRESSES'
export const FETCH_EMAIL_SETTINGS = 'FETCH_EMAIL_SETTINGS'
export const DELETE_EMAIL_CAMPAIGN = 'DELETE_EMAIL_CAMPAIGN'
